import * as Yup from 'yup';

import { signupWorkEnvironmentsOptions as defaultWorkEnvironmentOptions } from '../../../defaultFilters';

export const useSignupWorkEnvironmentFilter = ({ setFilters }) => {
  const workEnvironmentOptions = defaultWorkEnvironmentOptions;

  const formSchema = Yup.object().shape({
    signupWorkEnvironments: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSubmit = ({ signupWorkEnvironments }) => {
    setFilters({ signupWorkEnvironments });
  };

  return {
    formSchema,
    onSubmit,
    workEnvironmentOptions,
  };
};
